// data/languages/peul/categories/couleurs.ts

import { CategoryData } from '../../../../types/types';

export const couleurs: CategoryData = {
  // COULEURS DE BASE - Vérifiées selon sources académiques
  'Ɗaneejo': { translation: 'Blanc', translationEn: 'White', illustration: '⚪' }, // Corrigé de Raneewo
  'Ɓaleejo': { translation: 'Noir', translationEn: 'Black', illustration: '⚫', audio: 'Ff-Baleejo' },
  'Ɓodeejo': { translation: 'Rouge', translationEn: 'Red', illustration: '🔴', audio: 'Ff-Bodeejo' },
  'Ɓulaajo': { translation: 'Bleu', translationEn: 'Blue', illustration: '🔵', audio: 'Ff-Bulajo' },
  'Haako_ñiebe': { translation: 'Vert', translationEn: 'Green', illustration: '🟢', audio: 'Ff-Haako_niebe' }, // Corrigé de Haako
  'Oolo': { translation: 'Jaune', translationEn: 'Yellow', illustration: '🟡', audio: 'Ff-Oolo' }, // Corrigé de Oolu
   'Goro': { translation: 'Orange', translationEn: 'Orange', illustration: '🟠', audio: 'Ff-Goro' },

  // COULEURS COMPOSÉES ET NUANCÉES
  'Puro': { translation: 'Gris', translationEn: 'Grey', illustration: '⚪', audio: 'Ff-Puro' }, // Corrigé de Pure






};

export default couleurs;

export {};
